import React, { useCallback, useId, useState } from "react";
import { AvatarPlaceholder, AvatarPlaceholders, Camera, Cancel, PlusGrey, ProfileImg } from "../../../../components/styled/AllImages";
import { Box } from "../../../../components/styled/Elements";
import styled from "styled-components";
// import { useDropzone } from "react-dropzone";


const MultipleImageUploadDrag = () => {
    const [images, setImages] = useState([]); // Stores uploaded images
    const uniqueId = useId(); // Unique ID for input

    // Handle file selection (button click)
    const handleFileChange = (event) => {
        handleFiles(event.target.files);
    };

    // Handle drag-and-drop files
    const onDrop = useCallback((acceptedFiles) => {
        handleFiles(acceptedFiles);
    }, [images]);

    // Process uploaded files (from both button and drag-and-drop)
    const handleFiles = (files) => {
        const newImages = [...images];
        for (let i = 0; i < files.length; i++) {
            if (newImages.length < 20) { // Limit to 20 images
                newImages.push({
                    id: URL.createObjectURL(files[i]), // Temporary URL for preview
                    file: files[i], // Store file (optional, for upload)
                });
            }
        }
        setImages(newImages);
    };

    // Remove image by ID
    const removeImage = (id) => {
        setImages(images.filter((img) => img.id !== id));
    };

    // Dropzone settings
    /* const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { "image/*": [] }, // Accept all image types
        multiple: true,
    }); */

    return (
        <Box className="imageUploadContainer">
            {/* Drag and Drop Area */}
            {/* <Box {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
                <input {...getInputProps()} />
                <UploadCloud size={40} />
                <p>{isDragActive ? "Drop the images here..." : "Drag & drop images here, or click to select"}</p>
            </Box> */}

            {/* Images Preview */}
            <Box className="imagePreviewGrid">
                {images.map((image) => (
                    <Box key={image.id} className="imageThumbnail">
                        <img src={image.id} alt="preview" className="previewImage" />
                        <button className="deleteButton" onClick={() => removeImage(image.id)}>
                            <Cancel />
                        </button>
                    </Box>
                ))}

                {/* Plus Button for Uploading More */}
                {images.length < 20 && (
                    <Box className="addImageButton" onClick={() => document.getElementById(`imageInput-${uniqueId}`).click()}>
                        <PlusGrey />
                    </Box>
                )}
            </Box>

            {/* Hidden File Input */}
            <input
                id={`imageInput-${uniqueId}`}
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                multiple // Allow multiple file selection
                style={{ display: "none" }}
                onChange={handleFileChange}
            />
        </Box>
    );
};

export default MultipleImageUploadDrag;

const ImageUploadContainer = styled.div`
    .imageUploadContainer {
        display: flex;
        flex-direction: column;
        /* align-items: center; */
    }

    .imagePreviewGrid {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        /* justify-content: center; */
    }

    .imageThumbnail {
        position: relative;
        width: 113px;
        height: 100px;
        border-radius: 10px;
        overflow: hidden;
        background-color: var(--bg);
        border: 1px solid var(--border);
    }

    .previewImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .deleteButton {
        position: absolute;
        top: 5px;
        right: 5px;
        background: rgba(255, 0, 0, 0.7);
        color: white;
        border: none;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        svg{
            width: 10px;
            height: 10px;
            [stroke] {
                stroke: var(--white);
            }
            [fill] {
                fill: var(--white);
            }
        }
    }

    .addImageButton {
        width: 113px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        cursor: pointer;
        background-color: var(--bg);
        border: 1px solid var(--border);
    }
`
